import GridContainer from '@deltek/specification-client/core/Surfaces/GridContainer'
import GridItem from '@deltek/specification-client/core/Surfaces/GridItem'

import { isReactiveContentTeamFromStudioPage } from 'api/graphQL/reactiveVars/workspaceContent'
import { elementsGroupToggleStyles } from 'components/ElementsTree/styles/elementsGroupToggleStyles'
import VersionDropdown from 'components/Workspace2ActionBar/VersionDropdown'
import {
    useOMDropdownOptions,
    useSelectedOMVersion,
} from 'components/WorkspaceEditor/ActionBarStore'
import { useVersionManagement } from 'components/WorkspaceEditor/hooks/useActionBarHandler'
import { ElementPanelSubItem } from 'models/projectElements'
import { ProjectPageContext } from 'pages/ProjectsPage/ProjectPage/components/ProjectPageContext'
import React from 'react'
import { useOMWorkspace } from 'shared/hooks/useOMWorkspace'
import BulkAddBar from '../BulkAddBar2/BulkAddBar'
import { ElementsToggleFilterMenu } from './ElementsToggleFilterMenu'
import { GroupButton } from './GroupButton'

export interface ElementsGroupToggleProps {
    selectedGrouppingType?: ElementPanelSubItem
    handleChangeSelectGroupping?: (value: ElementPanelSubItem) => void
    handleChangeFilterOption?: (value: ElementPanelSubItem) => void
    searchBar?: React.ReactNode
    isSearchBarHiddenInSMMOM?: boolean
    isBulkAddBarVisible?: boolean
}

export const ElementsGroupToggle = ({
    selectedGrouppingType,
    handleChangeSelectGroupping,
    handleChangeFilterOption,
    searchBar,
}: ElementsGroupToggleProps) => {
    const contentTeamFromStudioPage = isReactiveContentTeamFromStudioPage()
        ?.value
    const { selectedBulkAddElements } = React.useContext(ProjectPageContext)
    const isBulkAddBarVisible = React.useMemo(
        () => selectedBulkAddElements && selectedBulkAddElements?.length !== 0,
        [selectedBulkAddElements]
    )
    const classes = elementsGroupToggleStyles({
        isSearchBarHiddenInSMMOM: false,
        isBulkAddBarVisible,
    })

    const { handleOMVersionSelectChange } = useVersionManagement()
    const omDropdownOptions = useOMDropdownOptions()
    const selectedOMVersion = useSelectedOMVersion()
    const { isCurrentlyOnOMWorkspace } = useOMWorkspace()

    const handleSelectElementGroup = React.useCallback(
        (groupValue: string) => {
            handleChangeSelectGroupping?.({
                ...selectedGrouppingType!,
                type: groupValue,
            })
        },
        [selectedGrouppingType, handleChangeSelectGroupping]
    )

    if (contentTeamFromStudioPage && isCurrentlyOnOMWorkspace) {
        return (
            <div className={classes.omVersionDropdownWrapper}>
                <VersionDropdown
                    handleChange={handleOMVersionSelectChange}
                    value={selectedOMVersion}
                    options={omDropdownOptions || []}
                    isOM
                />
            </div>
        )
    }

    return (
        <GridContainer
            data-testid="elementsGroupToggle"
            className={classes.elementsFilterContainer}
        >
            <>
                <GridItem className={classes.elementGroupButtonContainer}>
                    <GroupButton
                        label={'Divisions'}
                        selectedGrouppingType={selectedGrouppingType}
                        handleSelectElementGroup={handleSelectElementGroup}
                    />

                    <GroupButton
                        label={'Assemblies'}
                        selectedGrouppingType={selectedGrouppingType}
                        handleSelectElementGroup={handleSelectElementGroup}
                    />
                </GridItem>
                <ElementsToggleFilterMenu
                    selectedGrouppingType={selectedGrouppingType}
                    handleChangeFilterOption={handleChangeFilterOption}
                />
            </>
            {searchBar}
            {isBulkAddBarVisible && <BulkAddBar />}
        </GridContainer>
    )
}
